<template>
  <v-card class="mb-0 pb-0">
    <v-snackbar top :timeout="5000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-card-title class="headline"
      >Confirmar mandado
      <v-btn
        style="right: 10px; top: 10px"
        icon
        :disabled="loading"
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-row v-for="(point, index) of points" :key="index">
          <v-col cols="2" sm="2" md="2">
            <div class="number-c">
              {{ index + 1 }}
            </div>
          </v-col>

          <v-col cols="10" sm="10" md="10">
            <h3>
              <b>{{ point.zone }}</b>
              <i
                style="margin-left: 5px; margin-right: 5px"
                class="fas fa-long-arrow-alt-right"
              ></i>
              {{ point.address[0] }} {{ point.address[1] }}
            </h3>
            <p class="ma-0 pa-0 mt-3">
              Nombre de contacto :
              {{ point.contactName }}
            </p>
            <p class="ma-0 pa-0 mt-2">
              Teléfono de contacto :
              {{ point.contactPhone }}
            </p>
            <p v-if="point.comments" class="ma-0 pa-0 mt-2">
              Instrucciones :
              {{ point.comments }}
            </p>
          </v-col>
        </v-row>
        <v-row class="mb-0 pb-0">
          <v-col class="mb-0 pb-0" cols="12" sm="12" md="12">
            <v-btn
              rounded
              color="primary"
              block
              :disabled="loading"
              @click="next"
              height="50"
            >
              <i class="far fa-hand-holding-box mr-5"></i>
              {{ buttonText ? buttonText : "Crear Mandado" }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "details-dialog",
  props: [
    "waypoints",
    "routeData",
    "buttonText",
    "paymentData",
    "snackbarText",
    "snackbar",
  ],
  data() {
    return {
      points: [],
      loading: false,
    };
  },
  filters: {
    currency: function (amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HNL",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
  },

  methods: {
    next() {
      this.loading = true;
      this.$emit("success");
    },

    failed(e) {
      this.snackbarText = e;
      this.snackbar = true;
      this.loading = false;
    },
  },
  mounted() {
    for (let i = 1; i <= this.waypoints.length; i++) {
      this.points.push(this.routeData[`point_${i}`]);
    }
  },
};
</script>


<style lang="scss">
.fa-info-circle {
  cursor: pointer;
  padding: 0;
  color: gray;
  font-size: 30px !important;
}

.options {
  justify-content: flex-end !important;
}

.errands-container {
  color: #000000ad;
}

.number-c {
  background-color: #FF1744;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: white;
  padding: 3px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.point {
  padding: 15px;
}

.point-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  max-width: 100%;
  overflow: hidden;
}

.detail {
  text-align: left;
  padding: 5px;
  margin-left: 10px;
  font-size: 16px;

  max-width: 100%;
  overflow: hidden;
}

.close {
  width: 20px;
}

.status {
  border-radius: 40px;
  color: white !important;
}

.status-color {
  width: 10px;
  height: 10px;
}

.option {
  padding: 10px;
}

.headers {
  display: grid;
  grid-template-columns: 25% 28% 28% 16%;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  padding-top: 0;
}

select:focus,
select:focus {
  outline: none;
}

.filter-btn {
  padding: 15px;
  margin-left: 15px;
  width: 100%;
  cursor: pointer;
  background-color: #FF1744;
  color: white;
  border: none;
  border-radius: 20px;
}

.no-result {
  text-align: center;
  margin-top: 7%;
  color: gray;
  font-size: 25px;
}

.createParcel {
  width: 100%;
  appearance: none;
  border: none;
  outline: none;
  font-size: 16px;
  font-weight: bold;
  color: white;
  text-decoration: none;
  cursor: pointer;
  margin: 10px 5px 10px;
  box-sizing: content-box;
  text-align: center;
  padding: 5px 20px;
  height: 42px;
  line-height: 42px;
  border-radius: 18px;
  transition: 0.3s all;
  color: white;
  background-color: #FF1744;
  box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);

  i {
    top: 5px;
    left: -10px;
    position: relative;
    display: inline;
    font-size: 28px;
  }

  &:active {
    box-shadow: 0px 0px 30px rgba(#FF1744, 1);
  }

  &:disabled {
    color: #ccc;
    box-shadow: 0px 0px 10px rgba(#333, 0.2);
    background-color: white !important;
    cursor: not-allowed;
  }
}

.create {
  width: 100%;
  display: flex;
  justify-content: center;
}

.shipping {
  justify-content: flex-start;
  margin-top: 15px;
  margin-bottom: 15px;
}

.fa-hand-holding-box {
  font-size: 25px;
}
</style>